import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getGlobalMessageBoard, hideGlobalMessageBoard, hideMessageBoardKey } from "./actions";
import { CloseIcon } from "../icons";

const isValidDisplayPeriod = (start, end) => {
  return start && end && Date.parse(start) < Date.now() && Date.parse(end) > Date.now()
    ? true
    : false;
};

const isBoardHiddenExpiry = hideBoard => {
  const localHiddenSince = localStorage.getItem(hideMessageBoardKey);
  if (localHiddenSince) {
    return JSON.parse(localHiddenSince).ttl < Date.now();
  }
  return !hideBoard;
};

const shouldShowGlobalMsgBoard = props => {
  const {
    globalMessageBoard: { message, startDateTime, endDateTime, hideBoard },
  } = props;

  return (
    isBoardHiddenExpiry(hideBoard) && message && isValidDisplayPeriod(startDateTime, endDateTime)
  );
};

const GlobalMessageBoard = props => {
  const [isHovered, setIsHovering] = useState(false);
  useEffect(() => props.getGlobalMessageBoard(), []);

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  const {
    globalMessageBoard: { message },
    hideGlobalMessageBoard,
  } = props;

  return shouldShowGlobalMsgBoard(props) ? (
    <div
      style={{
        backgroundColor: "pink",
        height: "60px",
        overflow: "auto",
      }}
    >
      <CloseIcon
        style={{
          float: "right",
          position: "relative",
          top: "20px",
          left: "-20px",
          fill: isHovered ? "white" : "",
          backgroundColor: isHovered ? "green" : "",
        }}
        onClick={hideGlobalMessageBoard}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
      <div
        style={{
          marginLeft: "60px",
          marginRight: "60px",
          marginTop: "10px",
          marginBottom: "8px",
        }}
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </div>
  ) : (
    ""
  );
};

GlobalMessageBoard.propTypes = {
  globalMessageBoard: PropTypes.object,
  getGlobalMessageBoard: PropTypes.func.isRequired,
  hideGlobalMessageBoard: PropTypes.func.isRequired,
};
const mapStateToProps = ({ common: { globalMessageBoard } }) => ({ globalMessageBoard });
const mapDispatchToProps = {
  getGlobalMessageBoard,
  hideGlobalMessageBoard,
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalMessageBoard);



// WEBPACK FOOTER //
// ./components/common/global-message-board/GlobalMessageBoard.jsx